module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "显示名",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "节点类型",
      "prop": "level"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("模块")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父节点",
      "prop": "pid"
    }
  }, [_c('el-select', {
    staticClass: "w-200",
    attrs: {
      "placeholder": "父节点"
    },
    model: {
      value: (_vm.form.pid),
      callback: function($$v) {
        _vm.$set(_vm.form, "pid", $$v)
      },
      expression: "form.pid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-731b92e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/rule/add.vue
// module id = 1857
// module chunks = 2